import React from "react";
import "../styles.css";

const PrimaryCell = cellData => {
  return (
    <a
      style={{ color: "#007FBD", textDecoration: "underline" }}
      href={cellData.text}
      target="_blank"
      rel="noopener noreferrer"
    >
      {cellData.text}
    </a>
  );
};

export default PrimaryCell;
